import { required, shape, fromModel, when, items, email, stopOnFirstFailure } from "@totalsoft/pure-validations";
import { legalFormCodes } from "features/common/constants";
import { isEmpty } from "lodash";

export const partnerValidator = fromModel((model) =>
  !model.isIndividual
    ? shape({
        companyName: required,
        legalFormId: required,
        taxId: required,
        countryId: required,
      })
    : shape({
        firstName: required,
        lastName: required,
        genderId: required,
        pin: required,
        phone: required,
      })
);

export const partnerForSoleTraderFeatureValidator = fromModel((model) =>
  shape({
    companyName: required |> when(!model.isSoleTraderFeature),
    legalFormId: required |> when(!model.isSoleTraderFeature),
    registrationNumber:
      required |> when(Boolean(model?.legalFormCode) && model.legalFormCode !== legalFormCodes.partnership),
    registrationDate:
      required |> when(Boolean(model?.legalFormCode) && model.legalFormCode === legalFormCodes.partnership),
    areaOfActivityId:
      required |> when(Boolean(model?.legalFormCode) && model.legalFormCode === legalFormCodes.partnership),
    countryId: required |> when(!model.isSoleTraderFeature),
    countyId: required |> when(!model.isSoleTraderFeature),
    cityId: required |> when(!model.isSoleTraderFeature),
    street: required |> when(!model.isSoleTraderFeature),
    zip: required |> when(model.forUnitedKingdom && !model.isSoleTraderFeature),
    persons: items(
      fromModel((person) =>
        shape({
          firstName: required,
          lastName: required,
          pin: required |> when(!model.forUnitedKingdom),
          genderId: required,
          birthDate: required,
          countyId: required,
          cityId: required,
          street: required,
          zip: required |> when(model.forUnitedKingdom),
          email:
            [required |> when(model.dealerDrivenConsent), email |> when(!isEmpty(person.email))] |> stopOnFirstFailure,
          phone: required,
          nationality: required,
          registrationDate: required |> when(model.isSoleTraderFeature),
          areaOfActivityId: required |> when(model.isSoleTraderFeature),
          officialPartnerAddress:
            shape({
              countyId: required,
              cityId: required,
              street: required,
              zip: required |> when(model.forUnitedKingdom),
            }) |> when(person.addOfficialAddress),
        })
      )
    ),
  })
);

export const gdprValidator = items(
  fromModel(() =>
    shape({
      firstName: required,
      lastName: required,
      genderId: required,
      email: [required, email] |> stopOnFirstFailure,
    })
  )
);
